import classNames from "classnames";
import styles from "./ImageGallery.module.css";
import { Carousel } from "react-responsive-carousel";
import { PictureOrVideo } from "components/atoms";
import { useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { ContentOverlayBlock } from "components/organisms/Hero/components";
import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import $ from 'jquery';
import { CarouselDots } from "../CarouselDots";
import { useDeviceClassification } from "utils";


type ImageGalleryItemProps = {
  Alt: string;
  Src?: string;
  backgroundItem?: any;
};

export interface ImageGalleryProps {
  autoPlay?: boolean;
  interval?: number;
  fullscreen?: boolean;
  overlayContent?: JSX.Element[],
  isHero?: boolean,
  className?: string;
  images: ImageGalleryItemProps[];
  noCaption?: boolean;
  legendClassName?: string
}

const _ImageGallery = ({
  legendClassName,
  noCaption,
  autoPlay,
  interval,
  fullscreen,
  overlayContent,
  isHero,
  images,
  className = "",
  ...props
}: ImageGalleryProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const toggleIsOpen = () => setIsOpen(!isOpen);
  const [activeAlt, setActiveAlt] = useState<string>(images[0].Alt);
  const [activeIdx, setActiveIdx] = useState<number>(0);

  const { isDesktop } = useDeviceClassification();

  useEffect(() => {
    const ulDots = document.querySelector(".control-dots");
    const left = document.querySelector(".control-arrow.control-prev");
    const right = document.querySelector(".control-arrow.control-next");

    let liLeft = Object.assign(document.createElement("li"), {
      className: "dot dot-arrow dot-left",
    });
    liLeft.append(left);
    let liRight = Object.assign(document.createElement("li"), {
      className: "dot dot-arrow dot-right",
    });
    liRight.append(right);

    ulDots.prepend(liLeft);
    ulDots.append(liRight);

    images.length === 1 && $('.control-dots').css({ display: 'none' })
  }, []);

  const handleIsOpen = (bool: boolean) => {
    setIsOpen(!isOpen);
    if (bool) {
      document.querySelector('body').classList.add('no-scroll');
      document.getElementById("main-navigation")?.classList.remove("active");
    } else {
      document.querySelector('body').classList.remove('no-scroll')
    }
  };

  const handleChange = (e) => {
    setActiveIdx(e);
    setActiveAlt(images[e].Alt);
  };

  return (
    <div
      id="hero-gallery"
      className={classNames(
        styles.imagegallery,
        fullscreen && isOpen && styles.fullscreen,
        className,
        'ImageGallery',
        { fullscreenActive: fullscreen },
        { isHero: isHero }
      )}
      {...props}
    >

      {isOpen && (
        <button className={styles.closebutton} onClick={fullscreen ? () => handleIsOpen(false) : null}>
          <svg
            width="24"
            height="24"
            xmlns="http://www.w3.org/2000/svg"
            fillRule="evenodd"
            clipRule="evenodd"
          >
            <path
              fill="white"
              d="M12 11.293l10.293-10.293.707.707-10.293 10.293 10.293 10.293-.707.707-10.293-10.293-10.293 10.293-.707-.707 10.293-10.293-10.293-10.293.707-.707 10.293 10.293z"
            />
          </svg>
        </button>
      )}

      <Carousel
        preventMovementUntilSwipeScrollTolerance={true}
        swipeScrollTolerance={50}
        className={isHero && 'hero'}
        showArrows
        showStatus={false}
        autoPlay={autoPlay}
        interval={interval}
        showThumbs={false}
        onChange={(e) => handleChange(e)}
        infiniteLoop>
        {images.map(({ Alt, Src, backgroundItem }, i) => (
          <div key={`${Alt}-${i}`}>
            {!backgroundItem && overlayContent && overlayContent.length && <ContentOverlayBlock
              mobile
              key={`content-overlay-block-${Alt}`}
              blur={false}
              p={overlayContent[i]}
            />}

            <div
              className={styles.galleryitem}
              key={`gallery-image-${i}`}
              onClick={fullscreen ? () => handleIsOpen(true) : null}
            >

              <PictureOrVideo
                specifySize={{ width: 100, x: isHero ? 2.5 : 2 }}
                backgroundItem={backgroundItem}
                isHero={isHero}
                src={Src}
                alt={Alt || Src} />

              {!noCaption && fullscreen && Alt && (
                <p
                  className="legend"
                  dangerouslySetInnerHTML={{ __html: Alt }}
                ></p>
              )}
            </div>
          </div>
        ))}
      </Carousel>

      {
        !isDesktop && !isHero && images.length > 1 &&
        <CarouselDots
          style={{ position: 'relative' }}
          activeIdx={activeIdx}
          MediaPool={images}
          handleDotSelect={() => null}
        />
      }

      <AnimatePresence>
        {!noCaption && activeAlt && (
          <div className={styles.captionWrapper}>
            <motion.p
              initial={{ opacity: 0 }}
              exit={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { delay: .4 } }}
              key={`${activeAlt}`}
              className={`${legendClassName} legend`}
              dangerouslySetInnerHTML={{ __html: activeAlt }}
            ></motion.p>
          </div>
        )}
      </AnimatePresence>
    </div>

  );
};

export const ImageGallery = React.memo(_ImageGallery);
